import React from 'react';
import { Icon } from '../../utils/icons';

// Access level -> icon + label. Same labels as the modal's ACCESS map.
const ACCESS = {
    PUBLIC:          { icon: 'globe',           label: 'Public Event' },
    CHAPTER:         { icon: 'user-plus',       label: 'Members + Guests' },
    GLOBAL_FORUM:    { icon: 'users',            label: 'Global Forum' },
    WORKING_SESSION: { icon: 'lock',            label: 'Private Working Session' },
};

// Reusable meta "part": time · location · access. The chapter moved to the card's
// top tab (.agenda-card__chapter). Self-contained (.ec-meta), so it works in any
// card layout.
const EventMeta = ({ event }) => (
    <div className="ec-meta">
        {event.time_range && (
            <span className="ec-meta__item">
                <Icon name="clock" size={11} />
                {event.time_range}
            </span>
        )}
        <span className="ec-meta__item">
            <Icon name="pin" size={11} />
            {event.format}
        </span>
        {ACCESS[event.access] && (
            <span className="ec-meta__item">
                <Icon name={ACCESS[event.access].icon} size={11} />
                {ACCESS[event.access].label}
            </span>
        )}
    </div>
);

export default EventMeta;
